





































































































import { Component, Vue } from 'vue-property-decorator';
import { localize } from '@easygenerator/fragment-sdk';
import Config from '../../../config';
import { IDropdownItem } from '../../../types/types';
import ConfirmationPopup from '@/components/common/ConfirmationPopup.vue';

@Component({ components: { ConfirmationPopup } })
export default class Information extends Vue {
  profileForm: { [key: string]: string } = {
    name: this.user.name || '',
    country: this.user.country || '',
    city: this.user.city || ''
  };

  initialValues = { ...this.profileForm };

  formEdited = false;

  confirmation = false;

  countries: IDropdownItem[] = [];

  cities: IDropdownItem[] = [];

  selectedCountry: IDropdownItem | null = null;

  selectedCity: IDropdownItem | null = null;

  loadingCountries = true;

  loadingCities = true;

  formSubmitting = false;

  selectYourCityText = localize('selectYourCity');

  pleaseSelectCountryFirstText = localize('pleaseSelectCountryFirst');

  noCitiesAvailableText = localize('noCitiesAvailable');

  get user() {
    return this.$store.getters['user/user'];
  }

  get isFullNameIncorrect(): boolean {
    return this.profileForm.name.split(' ').filter(Boolean).length <= 1;
  }

  get cityDropdownPlaceholder(): string {
    if (!this.profileForm.country) {
      return this.pleaseSelectCountryFirstText;
    }

    if (this.cities.length === 0 && !this.loadingCities) {
      return this.noCitiesAvailableText;
    }

    return this.selectYourCityText;
  }

  get disableSaveBtn() {
    return !this.formEdited || this.isFullNameIncorrect;
  }

  onFieldChanged(fieldName: string, value: string | IDropdownItem) {
    switch (fieldName) {
      case 'country':
        this.onCountryUpdated(value as IDropdownItem);
        break;
      case 'city':
        this.onCityUpdated(value as IDropdownItem);
        break;
      default:
    }

    this.formEdited = Object.keys(this.profileForm as { [key: string]: string }).some(
      (field: string) => this.initialValues[field] !== this.profileForm[field]
    );
  }

  onContinueEditing() {
    this.confirmation = false;
  }

  onCancelEditing() {
    this.$router.push({ name: 'Dashboard' });
  }

  async onCountryUpdated(selectedCountry: IDropdownItem) {
    if (!selectedCountry) {
      return;
    }

    this.selectedCountry = selectedCountry;
    this.profileForm.country = selectedCountry.label!;
    this.loadingCities = true;
    this.cities = await Config.getInstance().getCities(selectedCountry.key);
    this.selectedCity = null;
    this.profileForm.city = '';
    this.loadingCities = false;
  }

  onCityUpdated(selectedCity: IDropdownItem) {
    if (!selectedCity) {
      return;
    }

    this.selectedCity = selectedCity;
    this.profileForm.city = selectedCity.label!;
  }

  async onSubmit() {
    this.formSubmitting = true;
    const result = await this.$store.dispatch('user/updateProfile', this.profileForm);

    if (result) {
      this.initialValues = { ...this.profileForm };
      this.formEdited = false;
    }

    this.formSubmitting = false;
  }

  async initForm() {
    this.loadingCountries = true;
    this.loadingCities = true;

    this.profileForm = {
      name: this.user.name || '',
      country: this.user.country || '',
      city: this.user.city || ''
    };

    if (this.user.country) {
      this.selectedCountry =
        this.countries.find((country: IDropdownItem) => country.label === this.user.country) || null;

      if (this.selectedCountry) {
        this.cities = await Config.getInstance().getCities(this.selectedCountry.key);

        if (this.user.city) {
          this.selectedCity = this.cities.find((city: IDropdownItem) => city.label === this.user.city) || null;
        }
      }
    }

    this.initialValues = { ...this.profileForm };

    this.loadingCountries = false;
    this.loadingCities = false;
  }

  async created() {
    this.countries = await Config.getInstance().getCountries();
    this.initForm();
  }

  handleBack() {
    if (this.formEdited) {
      this.confirmation = true;
    } else {
      this.onCancelEditing();
    }
  }
}
